var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.0926 3 6.04936 5.44378 3.62627 9H8.25C8.66421 9 9 9.33579 9 9.75C9 10.1642 8.66421 10.5 8.25 10.5H2.25C1.83579 10.5 1.5 10.1642 1.5 9.75V3.75C1.5 3.33579 1.83579 3 2.25 3C2.66421 3 3 3.33579 3 3.75V7.26752C5.22859 4.10671 7.6499 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.74967 22.5 2.40058 18.6472 1.62347 13.6145C1.56026 13.2051 1.84087 12.822 2.25023 12.7588C2.65959 12.6956 3.04269 12.9762 3.1059 13.3855C3.77181 17.6981 7.501 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM13.5 7.5C13.5 7.08579 13.1642 6.75 12.75 6.75C12.3358 6.75 12 7.08579 12 7.5V13.7865L9.41457 15.0792C9.04409 15.2644 8.89392 15.7149 9.07916 16.0854C9.2644 16.4559 9.71491 16.6061 10.0854 16.4208L13.0854 14.9208C13.3395 14.7938 13.5 14.5341 13.5 14.25V7.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/history.7514929846fb9f4c18c5655866e172fb.svg";